import { IconProps } from "../../../Types/IconProps";

function PlusIcon (props: IconProps) {
  return (
    <svg className={props.className} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 1H6V6L1 6V10H6V15H10V10H15V6L10 6V1Z" />
    </svg>
  );
}

export { PlusIcon }